import React, { useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import HeaderDetails from '../shared-components/HeaderDetails'
import Card from '../ui-elements/Card'
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import { getOrgImageUrl } from '../utils/getOrgImageUrl'
import YellowAlert from '../ui-elements/YellowAlert'
import AlertsForCheckPeriod from './AlertsForCheckPeriod'
import NotesForCheckPeriod from './NotesForCheckPeriod'
import { getCompletedScreenBackgroundClass } from '../utils/completedScreenEmojis'


function ExternalUserComplete() {

    const { tableData, t, externalUserState, handleLogout, organisationImageCode } = useContext(GlobalContext)
    const thisChecklistId = externalUserState && externalUserState.checklistId ? externalUserState.checklistId : null
    const thisChecklist = thisChecklistId && tableData && tableData.Checklists ? tableData.Checklists[thisChecklistId] : null
    const checklistName = thisChecklist ? thisChecklist.ChecklistName : ''
    const checklistPeriodId = externalUserState && externalUserState.checklistPeriodId ? externalUserState.checklistPeriodId : null
    const thisCheckPeriod = checklistPeriodId && tableData && tableData.ChecklistPeriods ? tableData.ChecklistPeriods[checklistPeriodId] : null
    const externalVisitorSettings = thisChecklist && thisChecklist.externalVisitorSettings
    const companyLogoUrl = externalVisitorSettings && externalVisitorSettings.companyLogo ? getOrgImageUrl(organisationImageCode, externalVisitorSettings.companyLogo) : null
    const checkPeriodAlerts = thisCheckPeriod ? thisCheckPeriod.alertsForCheckPeriod : null
    const checkPeriodNotes = thisCheckPeriod ? thisCheckPeriod.notesForCheckPeriod : null
 
    const hasAlerts = !!(checkPeriodAlerts && checkPeriodAlerts.length > 0)
    const useAlertsScreen = !!(externalVisitorSettings && externalVisitorSettings.differentScreenWithAlerts && hasAlerts)
    const screenEmoji = externalVisitorSettings ? (useAlertsScreen ? externalVisitorSettings.alertsCompletedEmoji : externalVisitorSettings.completedEmoji) : null
    const screenHeading = externalVisitorSettings ? (useAlertsScreen ? externalVisitorSettings.alertsCompletedHeading : externalVisitorSettings.completedHeading) : null
    const screenText = externalVisitorSettings ? (useAlertsScreen ? externalVisitorSettings.alertsCompletedText : externalVisitorSettings.completedText) : null
    const screenButtonText = externalVisitorSettings ? (useAlertsScreen ? externalVisitorSettings.alertsCompletedButtonText : externalVisitorSettings.completedButtonText) : null
    const screenUrl = externalVisitorSettings ? (useAlertsScreen ? externalVisitorSettings.alertsCompletedUrl : externalVisitorSettings.completedUrl) : null
    const backgroundClass = getCompletedScreenBackgroundClass(screenEmoji)

    const assetIdForThisCheckPeriod = thisCheckPeriod && thisCheckPeriod.AssetId
    const assetName = assetIdForThisCheckPeriod && tableData && tableData.Assets && tableData.Assets[assetIdForThisCheckPeriod] ? tableData.Assets[assetIdForThisCheckPeriod].AssetName : null


    if (!thisChecklist || !checklistPeriodId) {
        return <RedAlert>{t('Dashboard.ExternalUserDashboard.checklistOrPeriodNotFound')}</RedAlert>
    }

    return <Card fullwidth={true} backgroundClass={backgroundClass}>
        <div className={`w-full flex flex-col gap-6 items-center justify-center`}>
            <div className={`w-full flex flex-col gap-2 items-center justify-center`}>


                {!screenHeading && <>
                    <p className={`text-6xl text-center`}>
                        🏆
                    </p>
                    <p className={`text-center`}>
                        {t('Dashboard.ExternalUserDashboard.checklistComplete')}
                    </p>

                    <h2 className={`font-righteous text-brandblue text-2xl text-center`}>
                             {checklistName} {assetName && ` - ${assetName}`}
                    </h2>
                </>}

                {screenEmoji && <p className={`text-6xl text-center`}>{screenEmoji}</p>}

                {companyLogoUrl &&
                    <img src={companyLogoUrl} alt="Company Logo" className="max-w-64 max-h-64 pb-4" />}

              {screenHeading && 
                <h2 className={`font-righteous text-brandblue text-2xl text-center`}>{screenHeading}</h2>}

                {screenText && 
                <p className={``}>{screenText}</p>}



                {!screenHeading && hasAlerts && <AlertsForCheckPeriod thisCheckPeriod={thisCheckPeriod} />}
                {!screenHeading && checkPeriodNotes && checkPeriodNotes.length > 0 && <NotesForCheckPeriod thisCheckPeriod={thisCheckPeriod} />}

            </div>



            <div className={`w-full flex flex-row gap-2`}>
                {screenUrl && screenButtonText ? 
                <Button
                    onClick={ () => {
                        handleLogout()
                        window.open(screenUrl, '_blank')
                    }}
                    text={screenButtonText}
                    variant='primary'
                    size={`big`}
                    fullwidth={true}
                /> :
                
                <Button
                    onClick={handleLogout}
                    text={t('Dashboard.ExternalUserDashboard.logout')}
                    variant='primary'
                    size={`big`}
                    fullwidth={true}
                />
                }
            </div>
        </div>
    </Card>
}

export default ExternalUserComplete
